<template>
  <v-app>
    <v-container style="background-color: #f8f9fb; margin: 0px; padding: 0px">
      <v-col cols="12">
        <filtro-dinamico-one ref="filtroReceita" @filtrar="filterData" />
      </v-col>
    </v-container>

    <!-- Diálogo de progresso -->
    <v-dialog v-model="showProgress" persistent max-width="300">
      <v-card>
        <v-card-title> Baixando arquivo... </v-card-title>
        <v-card-text>
          <!-- Coloque aqui qualquer indicador de progresso que você deseja mostrar -->
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilter" persistent max-width="300">
      <v-card>
        <v-card-title> Mensagem </v-card-title>
        <v-card-text class="d-flex justify-center">
          {{ msg }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <!-- Centraliza horizontalmente -->
          <v-btn color="primary" @click="showFilter = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLimiteRegistrosDialog" persistent max-width="480">
      <v-card>
        <v-card-title>Aviso</v-card-title>
        <v-card-text class="text-center">
          Esta consulta contém mais de 500 mil registros
          ({{ totalRecords.toLocaleString('pt-BR') }} documentos).
          Recomendamos diminuir o período para realizar o download da planilha.
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-4">
          <v-btn color="primary" @click="showLimiteRegistrosDialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="background-color: #eee"
      id="contrato"
      fluid
      tag="section"
    >
      <v-row>
        

        <v-col cols="12" sm="6" lg="4">
          <div style="position: relative">
            <base-material-stats-card
              color="rgb(71 130 180)"
              icon="mdi-chart-line"
              title="Total esperado"
              sub-icon-color="red"
              :value="
                formatarMoeda(
                  this.totalEsperado
                )
              "
              :valuex="false"
              :sub-text="
                ''
              "
              :sub-text2="
                'Total de Documentos: ' + this.totalRecords
              "
            />
            
            <!-- Ícone de informação posicionado na área dos labels -->
            <div style="position: absolute; bottom: 12px; right: 12px; cursor: pointer">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="showInfoDialog = true"
                    color="primary"
                    size="20"
                    style="opacity: 0.7"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>Clique para mais informações</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>

        <!-- Dialog de informações detalhadas -->
        <v-dialog v-model="showInfoDialog" max-width="600" scrollable>
          <v-card>
            <v-card-title
              class="headline white--text"
              style="background-color: rgb(71 130 180)"
            >
              <v-icon color="white" class="mr-2">mdi-information</v-icon>
              O que é o Total Esperado?
            </v-card-title>
            <v-card-text class="pa-4">
              <p class="text-body-1">
                O <strong>Total Esperado</strong> representa a soma de todos os
                valores esperados de recebimento no período selecionado,
                considerando documentos que estão <strong>Pagos</strong> ou
                <strong>Em Aberto</strong>.
              </p>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="showInfoDialog = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Dialog de informações do Total Recebido -->
        <v-dialog v-model="showInfoDialogRecebido" max-width="600" scrollable>
          <v-card>
            <v-card-title
              class="headline white--text"
              style="background-color: rgb(71 130 180)"
            >
              <v-icon color="white" class="mr-2">mdi-information</v-icon>
              O que é o Total Recebido?
            </v-card-title>
            <v-card-text class="pa-4">
              <p class="text-body-1">
                O <strong>Total Recebido</strong> é a soma de todos os documentos recebidos no período.
              </p>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="showInfoDialogRecebido = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-col cols="12" sm="6" lg="4">
          <div style="position: relative">
            <base-material-stats-card
              color="rgb(71 130 180)"
              icon="mdi-cash"
              title="Total recebido"
              sub-icon-color="red"
              :valuex="false"
              :value="
                formatarMoeda(
                  this.totalrecebido 
                )
              "
              :sub-text="''"
              :sub-text2="
                'Documentos Recebidos no Périodo Selecionado '
              "
            />
            
            <!-- Ícone de informação posicionado na área dos labels -->
            <div style="position: absolute; bottom: 12px; right: 12px; cursor: pointer">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="showInfoDialogRecebido = true"
                    color="primary"
                    size="20"
                    style="opacity: 0.7"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>Clique para mais informações</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>

      <br />

      <v-divider></v-divider>

      <br /><br />

      <base-material-card
        icon="mdi-cash"
        title="Receitas"
        style="margin-top: 0px !important"
        color="rgb(71 130 180)"
        class="px-5 py-0"
      >
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="this.headers_vendas"
              :items="lista_dessert"
              :items-per-page="itemsPerPage"
              hide-default-footer
              :items-per-page-text="'Registros por página'"
              class="elevation-0 no-hover-effect"
            >
              <br />
              <br />
              <br />

              <template v-slot:top>
                <v-progress-linear
                  v-if="isLoading"
                  indeterminate
                  color="rgb(71 130 180)"
                ></v-progress-linear>
              </template>

              <template v-slot:item="row">
                <tr :class="{ 'cor-row': row.index % 2 !== 0 }">
                  <td
                    class="linha"
                    style="
                      width: 5%;
                      font-size: 11px !important;
                      font-weight: bold;
                      font-family: Verdana, Geneva, Tahoma, sans-serif;
                    "
                  >
                    {{ row.item.contrato ? row.item.contrato : "-------" }}
                  </td>

                  <td class="linha" style="width: 28%">
                    {{ row.item.nomePlano ? row.item.nomePlano : "-------" }}
                  </td>

                  <td class="linha" style="width: 18%">
                    {{ row.item.origem }}
                  </td>

                  <td class="linha" style="width: 6%">
                    {{
                      parseFloat(row.item.valor).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td class="linha" style="width: 6%">
                    {{ row.item.dtVencimento }}
                  </td>
                  <td class="linha" style="width: 6%">
                    {{
                      parseFloat(row.item.totalRecebido).toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )
                    }}
                  </td>

                  <td class="linha" style="width: 6%">
                    {{ row.item.dtRecebimento }}
                  </td>
                  <td class="linha" style="width: 6%">
                    {{ row.item.formaRecebimento }}
                  </td>
                  <td class="linha" style="width: 8%">
                    {{ row.item.situacaoDoc }}
                  </td>
                </tr>
              </template>

              <template v-slot:footer="{}">
                <v-spacer></v-spacer> <br />

                <v-row class="d-flex justify-center">
                  <v-col cols="12" sm="6">
                    <!-- Paginação padrão -->
                    <v-pagination
                      v-model="currentPage"
                      :length="totalPages"
                      @input="changePage"
                      :max="3"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <br />

        <div
          class="d-flex justify-end"
          style="color: #3055a4; font-size: 48px; margin-right: 12px"
        >
          <span
            @click="download_xls"
            style="
              color: green;
              font-size: 48px;
              margin-right: 12px;
              cursor: pointer;
            "
          >
            <i class="fas fa-file-excel"></i>
          </span>
        </div>
      </base-material-card>
    </v-container>
  </v-app>
</template>

<script>
import Contrato from "../../services/contrato";
import FiltroDinamicoOne from "./components/FiltroDinamicoOne.vue";

const LIMITE_REGISTROS_XLS = 500000;

export default {
  components: {
    FiltroDinamicoOne,
  },

  filters: {
    formatDate(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },

  name: "Contrato",

  data() {
    return {
      rules: {
        required: (value) => !!value || "Obrigatório.",
      },

      currentPage: 1, // Página atual
      itemsPerPage: 10, // Itens por página
      pageNumber: 1, // Número da página
      totalPages: 0,
      filterValues: [],
      msg: "",
      totalRecords: 0,
      totalrecebido: 0,
      totalEsperado: 0,
      totalrecebido_de_acordo: 0,
      totalEsperado_de_acordo: 0,
      total_contrato: 0,

      esperado_competecencia:0,
      esperado_acordos_competecencia: 0,
      total_doc_competecencia: 0,

      volume_recebidos_de_acordo: 0,
      volume_recebidos_sem_acordo: 0,

      showProgress: false,
      showFilter: false,
      showLimiteRegistrosDialog: false,
      showInfoDialog: false,
      showInfoDialogRecebido: false,
      selectedStartDate: null,
      selectedEndDate: null,
      selectedStartDateE: null,
      selectedEndDateE: null,
      selectedStartDateR: null,
      selectedEndDateR: null,
      selectedStartDateC: null,
      selectedEndDateC: null,
      selectedStartDateA: null,
      selectedEndDateA: null,
      origemDocumento: null,
      listDocBlack: false,
      selectedOpcao: null,

      headers_vendas: [
        {
          text: "Contrato",
          align: "start",
          sortable: false,
          value: "contrato",
        },
        { text: "Produto", value: "nomePlano", sortable: false },
        { text: "Origem", value: "origem", sortable: false },
        { text: "Valor", value: "valor", sortable: false },
        { text: "Vencimento", value: "dtVencimento", sortable: false },
        { text: "Recebido", value: "totalRecebido", sortable: false },
        { text: "Pagamento", value: "dtRecebimento", sortable: false },
        { text: "Forma Rec.", value: "formaRecebimento", sortable: false },
        { text: "Situação", value: "situacaoDoc", sortable: false },
      ],

      lista_dessert: [],
      isLoading: false,
    };
  },

  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
  },

  created() {
    // Defina a data atual como valor inicial para selectedStartDate
    this.loadPageData();
  },

  methods: {
    changePage() {
      this.isLoading = true;
      this.loadPageData();
      this.fetchData(this.currentPage);
    },

    handleCompanyChange(newValue) {
      this.selectedCompany = newValue;
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    loadPageData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    sincronizarListDocBlackDoFiltro() {
      const filtro = this.$refs.filtroReceita;
      if (filtro && typeof filtro.getListDocBlackAtivo === "function") {
        this.listDocBlack = filtro.getListDocBlackAtivo();
      }
    },

    filterData(valores) {
      // Mapear valores conforme estrutura fornecida
      this.selectedStartDate = valores.dataVencimentoInicial || null;
      this.selectedEndDate = valores.dataVencimentoFinal || null;
      this.selectedStartDateE = valores.dataEmissaoInicial || null;
      this.selectedEndDateE = valores.dataEmissaoFinal || null;
      this.selectedStartDateR = valores.dataPagamentoInicial || null;
      this.selectedEndDateR = valores.dataPagamentoFinal || null;
      this.selectedStartDateC = valores.dataCancelamentoInicial || null;
      this.selectedEndDateC = valores.dataCancelamentoFinal || null;
      this.selectedStartDateA = valores.dataAdesaoInicial || null;
      this.selectedEndDateA = valores.dataAdesaoFinal || null;
      this.origemDocumento = valores.origemDocumento || null;
      this.listDocBlack = valores.listDocBlack === true;
      this.selectedOpcao = valores.selectedOpcao || "Todas";

      this.produto = Array.isArray(valores.selectedProduto)
        ? valores.selectedProduto.join(",")
        : valores.selectedProduto || "Todos";

      // Concatena empresas se necessário
      this.selectedCompany = Array.isArray(valores.selectedCompany)
        ? valores.selectedCompany.join(",")
        : valores.selectedCompany || "Todas";

      // Ajusta o tipo selecionado
      this.selectedType =
        valores.selectedType === "Jazigo"
          ? "Cemitérios"
          : valores.selectedType || "Todos";

      this.isLoading = true;
      this.lista_dessert = [];
      this.currentPage = 1; // Página atual
      this.totalRecords = 0;
      this.totalrecebido = 0;
      this.totalrecebido_de_acordo = 0;
      this.totalEsperado = 0;
      this.totalEsperado_de_acordo = 0;
      this.total_contrato = 0;
      this.volume_recebidos_de_acordo = 0;
      this.volume_recebidos_sem_acordo = 0;
      this.esperado_competecencia = 0;
      this.esperado_acordos_competecencia = 0;
      this.total_doc_competecencia = 0;
      this.fetchData(1);
    },

    download_xls() {
      this.sincronizarListDocBlackDoFiltro();

      // Verifica se pelo menos um intervalo de datas está completo (inicial E final)
      const temVencimento = this.selectedStartDate && this.selectedEndDate;
      const temEmissao = this.selectedStartDateE && this.selectedEndDateE;
      const temPagamento = this.selectedStartDateR && this.selectedEndDateR;
      const temCancelamento = this.selectedStartDateC && this.selectedEndDateC;
      const temAdesao = this.selectedStartDateA && this.selectedEndDateA;

      if (!temVencimento && !temEmissao && !temPagamento && !temCancelamento && !temAdesao) {
        this.isLoading = false;
        this.msg = "Por favor, preencha pelo menos um intervalo de datas..";
        this.showFilter = true;
        return; // Interrompe a execução
      }

      // Calcula a diferença de dias diretamente
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        this.selectedStartDate,
        this.selectedEndDate
      );
      const diferencaEmDiasE = this.calcularDiferencaEntreDatas(
        this.selectedStartDateE,
        this.selectedEndDateE
      );
      const diferencaEmDiasR = this.calcularDiferencaEntreDatas(
        this.selectedStartDateR,
        this.selectedEndDateR
      );

      const diferencaEmDiasC = this.calcularDiferencaEntreDatas(
        this.selectedStartDateC,
        this.selectedEndDateC
      );
      const diferencaEmDiasA = this.calcularDiferencaEntreDatas(
        this.selectedStartDateA,
        this.selectedEndDateA
      );

      if (
        diferencaEmDiasE > 10000 ||
        diferencaEmDiasR > 10000 ||
        diferencaEmDias > 10000 ||
        diferencaEmDiasC > 10000 ||
        diferencaEmDiasA > 10000
      ) {
        this.isLoading = false;
        this.showFilter = true;
        this.msg =
          "A Diferença entre as datas não pode ser superior a 10000 dias.";

        return;
      }

      if (Number(this.totalRecords) > LIMITE_REGISTROS_XLS) {
        this.showLimiteRegistrosDialog = true;
        return;
      }

      this.showProgress = true;

      Contrato.lista_receita_xls(
        this.selectedStartDate,
        this.selectedEndDate,
        this.selectedStartDateR,
        this.selectedEndDateR,
        this.selectedStartDateE,
        this.selectedEndDateE,
        this.selectedStartDateC,
        this.selectedEndDateC,
        this.selectedStartDateA,
        this.selectedEndDateA,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto,
        this.origemDocumento,
        this.listDocBlack
      )
        .then((response) => {
          if (response.status === 200) {
            const fileName = `receitas_${Date.now()}.zip`;
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          // Lida com erros
          console.error("Erro ao baixar o arquivo Excel:", error);
        })
        .finally(() => {
          // Após o término do download, oculte o diálogo de progresso
          this.showProgress = false;
        });
    },
    calcularDiferencaEntreDatas(dataInicial, dataFinal) {
      const data1 = new Date(dataInicial);
      const data2 = new Date(dataFinal);

      // Verifique se as datas são válidas
      if (isNaN(data1) || isNaN(data2)) {
        return NaN; // Retorna NaN se uma das datas for inválida
      }

      const diferencaEmMilissegundos = data2 - data1;
      const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);

      return diferencaEmDias;
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateUS(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    formatarMoeda(valor) {
      // Verifica se o valor é numérico
      if (isNaN(valor)) {
        return "Valor inválido";
      }

      // Formata o valor como moeda brasileira (BRL)
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    getEndDateWithOffset(offsetDays) {
      const dataAtual = new Date();
      const primeiroDiaDoAno = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      ); // Janeiro é representado como 0

      // Crie a variável endDate aqui
      const endDate = new Date(primeiroDiaDoAno);

      // Adicione o número de dias ao endDate
      endDate.setDate(endDate.getDate() + offsetDays);

      return this.formatDateBR(endDate);
    },

    fetchData(pageNumber) {
      this.sincronizarListDocBlackDoFiltro();
      this.isLoading = true; // Mostra o indicador de carregamento

      // Verifica se pelo menos um intervalo de datas está completo (inicial E final)
      const temVencimento = this.selectedStartDate && this.selectedEndDate;
      const temEmissao = this.selectedStartDateE && this.selectedEndDateE;
      const temPagamento = this.selectedStartDateR && this.selectedEndDateR;
      const temCancelamento = this.selectedStartDateC && this.selectedEndDateC;
      const temAdesao = this.selectedStartDateA && this.selectedEndDateA;

      if (!temVencimento && !temEmissao && !temPagamento && !temCancelamento && !temAdesao) {
        this.isLoading = false;
        this.msg = "Por favor, preencha pelo menos um intervalo de datas..";
        this.showFilter = true;
        return; // Interrompe a execução
      }

      // Calcula a diferença de dias diretamente
      const diferencaEmDias = this.calcularDiferencaEntreDatas(
        this.selectedStartDate,
        this.selectedEndDate
      );
      const diferencaEmDiasE = this.calcularDiferencaEntreDatas(
        this.selectedStartDateE,
        this.selectedEndDateE
      );
      const diferencaEmDiasR = this.calcularDiferencaEntreDatas(
        this.selectedStartDateR,
        this.selectedEndDateR
      );

      const diferencaEmDiasC = this.calcularDiferencaEntreDatas(
        this.selectedStartDateC,
        this.selectedEndDateC
      );
      const diferencaEmDiasA = this.calcularDiferencaEntreDatas(
        this.selectedStartDateA,
        this.selectedEndDateA
      );

      // Valida a diferença de dias
      if (
        diferencaEmDias > 10000 ||
        diferencaEmDiasE > 10000 ||
        diferencaEmDiasR > 10000 ||
        diferencaEmDiasC > 10000 ||
        diferencaEmDiasA > 10000
      ) {
        this.isLoading = false;
        this.showFilter = true;
        this.msg =
          "A Diferença entre as datas não pode ser superior a 10000 dias.";
        return; // Interrompe a execução
      }

      // Faz a chamada ao método da API diretamente com as propriedades
      Contrato.lista_receita(
        this.selectedStartDate,
        this.selectedEndDate,
        this.selectedStartDateR,
        this.selectedEndDateR,
        this.selectedStartDateE,
        this.selectedEndDateE,
        this.selectedStartDateC,
        this.selectedEndDateC,
        this.selectedStartDateA,
        this.selectedEndDateA,
        this.selectedCompany,
        this.selectedType,
        this.selectedOpcao,
        this.produto,
        this.origemDocumento,
        pageNumber,
        this.itemsPerPage,
        this.listDocBlack
      )
        .then((response) => {
          if (response.status === 200) {
            this.lista_dessert = response.data.content;
            this.totalPages = response.data.totalPages; // Total de páginas disponíveis
            this.loading = false; // Esconder o loading após a pesquisa
            // Atualize o número da página atual ou outras variáveis de controle, se necessário
            this.totalRecords = response.data.totalElements; // Substitua totalRecordsFromApi pelo valor real
            this.total_contrato = response.data.total_contrato; // Substitua totalRecordsFromApi pelo valor real
            this.totalEsperado=
              response.data.totalEsperado; // Substitua totalRecordsFromApi pelo valor real
            this.totalrecebido =
              response.data.totalRecebido; // Substitua totalRecordsFromApi pelo valor real
            this.totalEsperado_de_acordo =
              response.data.totalEsperado_de_acordo;
              
          }
        })
        .catch((e) => {
          // Lida com erros
          this.isLoading = false;
          this.totalRecords = 0;
          this.totalrecebido = 0;
          this.totalEsperado = 0;
          this.total_contrato = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};

function converteDataParaFormatoISO(dataNoFormatoBR) {
  // Verifica se o valor passado é vazio, nulo ou indefinido
  if (!dataNoFormatoBR) {
    return null;
  }

  const partes = dataNoFormatoBR.split("/");
  if (partes.length === 3) {
    const [dia, mes, ano] = partes;
    return `${ano}-${mes}-${dia}`;
  }
  return null; // Retorna null se a data estiver em um formato inválido
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.custom-gray-background {
  height: 90px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto !important;
  margin: -12px;
}

/* Defina uma classe para preencher a largura horizontalmente e centralizar verticalmente */
.fill-width {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.v-menu__content {
  box-shadow: none !important;
  top: 4px !important;
}
/* Centralize horizontalmente */
.justify-center {
  justify-content: center;
}

/*rgb(71 130 180)*/
.gray-row {
  background-color: rgb(
    71 130 180
  ); /* ou qualquer outra cor cinza que você preferir */
}
.cor-row {
  background-color: rgb(231 244 255);
  transition: none !important; /* Desativa a transição de cor */
}

.linha {
  font-size: 11px !important;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.no-hover-effect.v-data-table tbody tr:hover {
  color: #3055a4;
}
.card-container {
  display: flex;
  justify-content: space-around; /* ou outro alinhamento que desejar */
}
</style>
